// extracted by mini-css-extract-plugin
export default {"Input":"Input_Input__aCYn4","Selected":"Input_Selected__hCIfI"};